import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import PasswordField from "../components/PasswordField";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const email = params.get("email") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    if (password !== confirm) { toast.error("Passwords do not match."); return; }
    setLoading(true);
    try {
      await api.post("/customer/reset-password", { email, token, password });
      setDone(true);
      toast.success("Password reset. You can now sign in.");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This reset link is invalid or expired.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-taven-gray/30" data-testid="reset-page">
      <div className="w-full max-w-md bg-white border border-black/10 p-8 md:p-10">
        <h1 className="text-xl font-black font-display text-center">Set a new password</h1>
        {!token || !email ? (
          <p className="text-sm text-muted-foreground text-center mt-4" data-testid="reset-invalid">This reset link is missing or invalid. Please request a new one from <Link to="/forgot-password" className="text-taven-gold hover:underline">Forgot Password</Link>.</p>
        ) : done ? (
          <p className="text-sm text-muted-foreground text-center mt-4" data-testid="reset-success">Your password has been reset. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-xs text-muted-foreground text-center">Resetting password for <strong>{email}</strong></p>
            <PasswordField value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" testId="reset-password" />
            <PasswordField value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" testId="reset-confirm" />
            <button disabled={loading} data-testid="reset-submit" className="w-full bg-taven-black text-white font-bold uppercase tracking-wider py-4 hover:bg-taven-orange transition-colors disabled:opacity-60">{loading ? "Resetting…" : "Reset Password"}</button>
          </form>
        )}
        <p className="mt-6 text-center text-sm"><Link to="/login" className="text-taven-gold hover:underline">Back to sign in</Link></p>
      </div>
    </div>
  );
}
